export enum UserStatus {
  online = 'userStatusOnline',
  offline = 'userStatusOffline',
}

export interface iStatus {
  status: {
    '@type': UserStatus,
    was_online: number
  }
  user_id: number
}

export interface iPin {
  chat_id: number
  is_pinned: boolean
  order: string
}
